import React, { ReactNode } from 'react';
import './Loading.less';
import Spinner from '../Spinner/Spinner';

const Loading = ({ text, size = 100, showSpinner = true }: { text: string | ReactNode; size?: number; showSpinner?: boolean }) => {
    return (
        <div className="loading">
            {showSpinner && (
                <div className={'text-primary'}>
                    <Spinner size={size} />
                </div>
            )}
            <div className={'loading-text'}>{text}</div>
        </div>
    );
};

export default Loading;
